import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

const Header = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "20px",
}));
const Linked = styled(Link)(({ theme }) => ({ height: "50px" }));

const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    marginBottom: "10px",
  },
  "& p": {
    ...theme.authsubTit,
    marginBottom: "5px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(11, 11, 11, 0.6)",
    "& span": {
      color: "#0B0B0B !important",
      paddingLeft: "5px",
      fontWeight: 500,
    },
  },
}));
const ResendMain = styled("div")(({ theme }) => ({
  textAlign: "center",
  marginTop: "120px",
  "& span": {
    fontFamily: theme.typography.fontFamily,
    color: "rgba(11, 11, 11, 0.5)",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
  },
  "& button": {
    backgroundColor: "transparent",
    border: "none",
    color: "rgb(11, 11, 11)",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    cursor: "pointer",
    lineHeight: "25px",
    "&:disabled": {
      color: "rgba(11, 11, 11, 0.5)",
      cursor: "not-allowed",
    },
  },
  [theme.breakpoints.down("md")]: {
    marginTop: "150px",
  },
}));

const VerificationMain = styled("div")(({ theme }) => ({
  marginTop: "25px",
  "& div:first-child": {
    justifyContent: "space-between",
  },
  "&  input": {
    background: "#F2F2F2",
    borderRadius: "12px",
    border: "none",
    width: "60px !important",
    height: "60px",
  },
}));

const TimeCounter = styled("div")(({ theme }) => ({
  marginTop: "40px",
  textAlign: "center",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "25px",
  color: "#0B0B0B",
}));

export {
  Header,
  Linked,
  Maincontant,
  ResendMain,
  VerificationMain,
  TimeCounter,
};
